export const STOP_POLLING_TYPE = 'polling/STOP_POLLING_TYPE';
